<template>
  <div>
    <AppSystemBarAdBlock />
    <app-toolbar class="app--toolbar" />
    <app-drawer class="app--drawer" />
    <v-content>
      <v-container
        grid-list-xl
        fluid
      >
        <AppErrorAlert />
        <v-layout
          row
          wrap
        >
          <slot />
        </v-layout>
      </v-container>
    </v-content>
    <v-footer
      inset
      app
      height="auto"
      class="pa-3 app--footer"
    >
      <span class="caption">Coopermais &copy; {{ new Date().getFullYear() }}</span>
    </v-footer>
  </div>
</template>
<script>
import AppDrawer from '@/components/AppDrawer'
import AppToolbar from '@/components/AppToolbar'
import AppSystemBarAdBlock from '@/components/AppSystemBarAdBlock'
import AppErrorAlert from '@/components/AppErrorAlert.vue'
export default {
  components: {
    AppDrawer,
    AppToolbar,
    AppSystemBarAdBlock,
    AppErrorAlert
  }
}
</script>
<style lang="stylus" scoped>
.setting-fab {
  top: 50% !important;
  right: 0;
  border-radius: 0;
}

.page-wrapper {
  min-height: calc(100vh - 64px - 50px - 81px);
}
</style>
